var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.17969C6.97 2.17969 2.5 6.64969 2.5 12.1797C2.5 17.7097 6.97 22.1797 12.5 22.1797C18.03 22.1797 22.5 17.7097 22.5 12.1797C22.5 6.64969 18.03 2.17969 12.5 2.17969ZM17.5 15.7697L16.09 17.1797L12.5 13.5897L8.91 17.1797L7.5 15.7697L11.09 12.1797L7.5 8.58969L8.91 7.17969L12.5 10.7697L16.09 7.17969L17.5 8.58969L13.91 12.1797L17.5 15.7697Z",
    fill: "#BA1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelFilled);
export default __webpack_public_path__ + "static/media/CancelFilled.a58a0181013ffb0d42c8c39861c24076.svg";
export { ForwardRef as ReactComponent };